import React, { Component, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import MobileStepper from '@material-ui/core/MobileStepper';
// import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import ChooseArbitrator from './ChooseArbitrator';
import SignatureCanvasWrapper from './SignatureCanvasWrapper';
import Verification from '../Auth/Verification';
import UploadDocs from './UploadDocs';
import UploadDocsForOnBoarding from './UploadDocsForOnBoarding';
import Payment from './Payment';
import { connect } from 'react-redux';
import { Link, Redirect, withRouter } from 'react-router-dom';
import axios from 'axios';
import * as actions from '../../store/actions/index';
import PrimaryAppBar from '../../components/PrimaryAppBar';
import ReadPDF from './ReadPDF';
import CircularProgress from '@material-ui/core/CircularProgress';
import { isEmpty } from 'lodash';
import queryString from 'query-string';
import UserInfo from './UserInfo';
import withSizes from 'react-sizes';
import ChatbotResponse from './ChatbotResponse';
import Footer from '../Footer/Footer';
import ChatbotResponseChi from './ChatbotResponseChi';
import SettingsIcon from "@material-ui/icons/Settings";
import Icon1 from '../../images/step1.jsx'
import Icon2 from '../../images/step2.jsx'
import Icon3 from '../../images/step3.jsx'
import Icon4 from '../../images/step4.jsx'
import Icon5 from '../../images/step5.jsx'
import Icon6 from '../../images/step6.jsx'
import SvgIcon from "@material-ui/core/SvgIcon";
import { ReactComponent as Logo1 } from "../../images/step1.svg";
import { ReactComponent as Logo2 } from "../../images/step2.svg";
import { ReactComponent as Logo3 } from "../../images/step3.svg";
import { ReactComponent as Logo4 } from "../../images/step4.svg";
import { ReactComponent as Logo5 } from "../../images/step5.svg";
import { ReactComponent as Logo6 } from "../../images/step6.svg";
import CustomStepper from './CustomStepper';
import 'antd/dist/antd.css';
import PropTypes from 'prop-types';

import { Steps } from 'antd';
import { LaptopWindowsSharp, ThreeSixtySharp } from '@material-ui/icons';

const { Step } = Steps;

var self;

const styles = theme => ({
  root: {
    width: '100%'
  },
  button: {
    margin: theme.spacing.unit,
  },
  completed: {
    display: 'inline-block',
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    display: 'flex',
    justifyContent: 'center',
  },
  buttonContainer: {
    display: 'flex',
    marginTop:'-60px',
    justifyContent: 'center',
  },
  progress: {
    margin: theme.spacing.unit * 3,
  },
  // icon:{
  //   color: 'green',
  // "&$activeIcon": {
  //   color: 'red'
  // },
  // "&$completedIcon": {
  //   color: 'black'
  // }

  labelContainer: {
    "& $alternativeLabel": {
      marginTop: 0
    }
  },
  step: {
    "& $completed": {
      color: "lightgreen"
    },
    "& $active": {
      color: "pink"
    },
    "& $disabled": {
      color: "red"
    }
  },
  alternativeLabel: {},
  active: {}, //needed so that the &$active tag works
  completed: {},
  disabled: {},
  labelContainer: {
    "& $alternativeLabel": {
      marginTop: 0
    }
  },
  bInput: {
    background: "rgba(255, 255, 255, 0.5)",
    outline: "0",
    color: "#99192D",
    wordWrap: "break-word",
    wordBreak: "break-word",
    border: "2px solid #99192D",
    paddingTop: "15px",
    textTransform: 'none',
    paddingBottom: "15px",
    borderRadius: "25px",
    // height: "30px",
    marginLeft: "3px",
    marginRight: "3px",
    boxSizing: "border-box",
    fontSize: "16px",
    "&:hover": {
      color: "white",
    },
  },
  footRespondent: {
    marginTop: "1000px",
    '@media (max-width: 480px)': {
      marginTop: '60px'
    },
    '@media (max-width: 510px)': {
      marginTop: '800px'
    }
  },
  footClaimant: {
    marginTop: "1500px",
    '@media (max-width: 480px)': {
      marginTop: '60px'
    },
    '@media (max-width: 510px)': {
      marginTop: '800px'
    }
  },
  footAward: {
    marginTop: "1000px",
    '@media (max-width: 480px)': {
      marginTop: '60px'
    },
    '@media (max-width: 510px)': {
      marginTop: '800px'
    }
  },
});

function getSteps() {
  return ['Chatbot', 'Verification', 'Choose Arbitrator', 'Read PDF', 'Signature', 'Payment', 'Upload Documents'];
}

class GetStepContent extends Component {

  render(){
    const {step, handleArbitratorChange, conversationId, handleComplete, onUserInfoRef, removeConfirmButton, isSpecialSignatureVerified} = this.props;
    switch (step) {
      case 0:
        return <ChatbotResponse style={{width:'100%', marginTop:'20px'}} />;
      case 1:
        return <Verification handleComplete={handleComplete}/>
      case 2:
        return <ChooseArbitrator setArbitrator={handleArbitratorChange} handleComplete={handleComplete}/>
      case 3:
        return <ReadPDF removeConfirmButton={removeConfirmButton} conversationId={conversationId} handleComplete={handleComplete}/>
      case 4:
        return <SignatureCanvasWrapper isSpecialSignatureVerified={isSpecialSignatureVerified} conversationId={conversationId} handleComplete={handleComplete}/>;
      case 5:
        return <Payment handleComplete={handleComplete} />
      case 6:
        return <UploadDocsForOnBoarding handleComplete={handleComplete}/>
      default:
        return 'Unknown step';
    }
  }
  
}

class OnBoarding extends Component {
  state = {
    setArbitrator: null,
    activeStep: 0,
    completed: {},
    newAccount: true,
    skipped: new Set(),
    ConfirmButtonVisible: true,
    isLoading: true,
    isSpecialSignatureVerified: false,
    signingClicked: false,
  };
  
  removeConfirmButton = function(){
    self.setState({
      ConfirmButtonVisible: false
    })
  }

  checkLanguage = function() {
    try{
        // console.log('this caseData: '+JSON.stringify(this.props.caseData))
        var lang = localStorage.getItem('language');
        if (this.props !== undefined){
          if (this.props.caseData != null){
            if (this.props.caseData.language !== undefined){
              if (this.props.caseData.language == 'Chi'){
                if (lang == 'en' || lang == undefined){
                  localStorage.setItem('language', 'cn');
                  setTimeout(()=>{
                      window.location.reload();
                  },100)
                }
              }
              else if (this.props.caseData.language == 'Eng'){
                if (lang == 'cn' || lang == undefined){
                  localStorage.setItem('language', 'en');
                  setTimeout(()=>{
                      window.location.reload();
                  },100)
                }
              }
            }
          }
        }
    }catch(err){
      console.log(err)
      setTimeout(()=>{this.checkLanguage()},100)
    }
  }

  componentWillMount(){
    console.log('in onBoarding componentWillMount')
    this.props.getUserInformation(localStorage.getItem('token'));
    this.props.getCaseInfo(this.props.match.params.id, localStorage.getItem('token'));

     let search = this.props.location.search || null;
     if(search){
      const values = queryString.parse(search);
      const username = values.username || null;
      const password = values.password || null;
      this.props.onAuth(username, password);
     }
     console.log(`###steps_completed ${this.props.steps_completed}`)
      let completed = this.modifyStepsCompleted(this.props.steps_completed);
      let unCompleted = this.modifyStepsUnCompleted(completed);
      this.setState({
        'completed' : completed,
        activeStep: Object.keys(unCompleted).length > 0 ? parseInt(Object.keys(unCompleted)[0]) : 0,
      })
  }

  componentDidMount(){
    console.log(`FM onBoarding ${this.props.caseData}`)
    self = this;
    this.props.getUserInformation(localStorage.getItem('token'));
    this.props.getCaseInfo(this.props.match.params.id, localStorage.getItem('token'));

    if((window.parent.location.href).includes('/chatbot')){
      window.parent.location.href = '/odr';
    }
    // 

    console.log('in onBoarding componentDidMount this.props.steps_completed: '+this.props.steps_completed+' this.props.userType: '+this.props.userType)
    setTimeout(()=>{
      this.setState({
        isLoading: false
      })
    },5000 )
    this.checkLanguage();

    const currentUrl = ''+window.location.href
    console.log('currentUrl: '+currentUrl+ ' '+(!currentUrl.includes('/chatbot')))
    if (!currentUrl.includes('/chatbot')){
      // window.parent.location.reload('/odr')
      window.parent.postMessage('redirectToCases', '*');
    }

  }

  componentDidUpdate(prevProps, prevState){
    console.log('inside component did update: this.props.newAccount: '+JSON.stringify(this.props.newAccount));
    const twofa = localStorage.getItem('twofa');
    if(!this.props.newAccount && twofa){
      return(<Redirect to={`/cases/${this.props.match.params.id}/home`} />)
    }
    
    if(JSON.stringify(prevProps.steps_completed) != JSON.stringify(this.props.steps_completed)){  
      if(!isEmpty(this.props.steps_completed)){
        let completed = this.modifyStepsCompleted(this.props.steps_completed);
        let unCompleted = this.modifyStepsUnCompleted(completed);
        if(JSON.stringify(prevState.completed) != JSON.stringify(completed) && prevState.activeStep == this.state.activeStep){
          this.setState({
            'completed' : completed,
            activeStep: Object.keys(unCompleted).length > 0 ? parseInt(Object.keys(unCompleted)[0]) : 0,
        })
        }
      } 
    }
    if(!(this.props.newAccount == null)){
      if(prevProps.newAccount != this.props.newAccount){
        this.setState({
          newAccount: this.props.newAccount,
        })
      }
    }
  }

  modifyStepsUnCompleted = (completed) => {
    let steps_init= {};
    getSteps().forEach((key, index) => {
      steps_init[index] = false;
    })
    let completed_init= {
      ...steps_init,
      ...completed,
    }
    let unCompleted = {};
    Object.keys(completed_init).map((key, index) => {
      if(!completed_init[key]){
        unCompleted[index]= completed_init[key]
      }
    })
    return unCompleted;
  }

  modifyStepsCompleted = (steps_completed) => {
    console.log(`FM modifyStepsCompleted ${steps_completed}`);
    let completed = {};
    if(steps_completed){
      Object.keys(steps_completed).map((key, index) => {
        if(steps_completed[key]){
          completed[index]= steps_completed[key]
        }
      })
    }
    return completed;
  }

  handleArbitratorChange = (arbitrator) => {
    this.setState({setArbitrator: arbitrator});
  }

  totalSteps = () => {
    return getSteps().length;
  };

  isStepOptional = step => {
    try{
      let uniqueId = localStorage.getItem('token');
      let userType = '';
      if(this.props.caseData.claimantUniqueId == uniqueId){
          userType = 'claimant';
      }else if(this.props.caseData.respondentUniqueId == uniqueId){
          userType = 'respondent';
      }
  else{
    userType = "claimant";
  }

      if(userType == 'respondent'){
        // return step === 3 || step === 5 || step == 6;
        return step === 5 || step == 6;
        // return true;
      }
      else{
        // return step === 3 || step == 6;
        return step == 6;
      }
    }catch(err){
      console.log('isStepOptiona err: '+err)
      // return step === 6 || step === 3 || step === 5;
      return true;
    }
  };

  handleSkip = () => {
    const { activeStep } = this.state;
    if (!this.isStepOptional(activeStep)) {
      // You probably want to guard against something like this
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }
    this.props.onBoardingStepCompletion(localStorage.getItem('token'), this.props.match.params.id, this.props.userType, this.state.activeStep + 1);
  };

  handleNext = () => {
    let activeStep;
    if (this.isLastStep() && !this.allStepsCompleted()) {
      // It's the last step, but not all steps have been completed,
      // find the first step that has been completed
      const steps = getSteps();
      activeStep = steps.findIndex((step, i) => !(i in this.state.completed));
    } else {
      activeStep = this.state.activeStep + 1;
    }
    this.setState({
      activeStep,
    });
  };

  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1,
    }));
  };

  handleStep = step => () => {
    this.setState({
      activeStep: step,
    });
  };

  handleComplete = async (isSignatureVerifyNeeded = undefined) => {
    console.log('handleComplete isSignatureVerifyNeeded: ',isSignatureVerifyNeeded)
    const { completed } = this.state;

    if((''+this.props.email).endsWith('@primecredit.com') && (this.completedSteps() === this.totalSteps() - 1)){
      const response = await axios.post('https://www.hkarbsoc.org.hk:9000/sendEmailToManagerToSign', { 'caseId': this.props.caseId });
      if (response.data == 'saved') {
        alert(this.context.t('An email has been sent for signing.'))
      }
      window.parent.location.href = '/odr'; 
    }
    else if(isSignatureVerifyNeeded == undefined){
      this.props.onBoardingStepCompletion(localStorage.getItem('token'), this.props.match.params.id, this.props.userType, this.state.activeStep + 1);
    }
    else if (isSignatureVerifyNeeded == true){
      this.setState({
        isSpecialSignatureVerified: true
      })
    }
    else{
      this.props.onBoardingStepCompletion(localStorage.getItem('token'), this.props.match.params.id, this.props.userType, this.state.activeStep + 1);
    }
  };
 
  handleReset = () => {
    this.setState({
      activeStep: 1,
      completed: {},
    });
  };

  completedSteps() {
    console.log('completedSteps: '+Object.keys(this.state.completed).length)
    return Object.keys(this.state.completed).length;
  }

  isLastStep() {                
    return this.state.activeStep === this.totalSteps() - 1;
  }

  allStepsCompleted() {
    return this.completedSteps() === this.totalSteps();
  }

  render() {
    const { classes } = this.props;
    const steps = getSteps();
    const { activeStep } = this.state;
    console.log('activeStep: '+activeStep)
    if(!this.props.isAuthenticated){
      return(<Redirect to='/' />)
    }
    if(this.props.caseData == null || this.props.caseData == undefined){
      return(<Redirect to='/cases' />)
    }
    const twofa = localStorage.getItem('twofa');
    if(this.props.newAccount !== null && this.props.newAccount !== undefined && !this.props.newAccount && twofa){
        return(<Redirect to={`/cases/${this.props.match.params.id}/home`} />)
    }

    if (this.state.isLoading) {
      return(<div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height:'100%',
          verticalAlign:'middle'
        }}
      ><CircularProgress size={50} thickness={3} style={{}} className={classes.progress}/></div>);
    }
    else{
      return (
        <div className={classes.root}>
          <div style={{ width: '100vw', display: 'block',  margin: '0 auto',  }}>
          <CustomStepper activeStep={activeStep}/>
          </div>
          <div>
            {this.allStepsCompleted() ? (
              <div>
                <Typography className={classes.instructions}>
                  All steps completed - you&apos;re case has been successfully registered.
                </Typography>
                <Button onClick={this.handleReset}>Reset</Button>
                {this.props.history.push(`/cases/${this.props.match.params.id}/home`)}
              </div>
              ) : (
              <div>
                {
                  (activeStep !== 1 && activeStep !== 5 && activeStep !== 6)?
                  <Typography className={classes.instructions}>
                  {
                    (this.props.loadingCaseInfo || this.props.loadingStepCompleted) ? 
                      <CircularProgress size={50} thickness={3} className={classes.progress}/> : 
                      <GetStepContent isSpecialSignatureVerified={this.state.isSpecialSignatureVerified} step={activeStep} handleArbitratorChange={this.handleArbitratorChange} conversationId={this.props.conversationId} handleComplete={this.handleComplete} removeConfirmButton={this.removeConfirmButton} onUserInfoRef={ref => (this.userInfoChild = ref)}/>
                  }
                  </Typography>:  (this.props.loadingCaseInfo || this.props.loadingStepCompleted) ? 
                      <CircularProgress size={50} thickness={3} className={classes.progress}/> : 
                      <GetStepContent isSpecialSignatureVerified={this.state.isSpecialSignatureVerified} step={activeStep} handleArbitratorChange={this.handleArbitratorChange} conversationId={this.props.conversationId} handleComplete={this.handleComplete} removeConfirmButton={this.removeConfirmButton} onUserInfoRef={ref => (this.userInfoChild = ref)}/>
                }
  
                <div className={classes.buttonContainer}>
                  {activeStep !== steps.length &&
                    (this.state.completed[this.state.activeStep] ? (
                      <Typography variant="caption" className={classes.completed}>
                        Step {activeStep + 1} already completed
                      </Typography>
                    ) : (
                      (this.isStepOptional(activeStep)) ? this.state.activeStep !== 3 && 
                      <Button style={{marginTop:'0px', marginBottom:'15px'}} variant="contained" color="primary" onClick={this.handleComplete} className={classes.bInput} disabled={this.props.loadingCaseInfo || this.props.loadingStepCompleted}>
                        {
                          !(''+this.props.email).endsWith('@primecredit.com') ? (this.completedSteps() === this.totalSteps() - 1 ? this.context.t('Finish') :  this.state.activeStep === 3 ? this.context.t('Confirm') : this.context.t('Next')) : this.context.t('Request Signature')
                        }
                      </Button>
                      :
                      null
                    ))}
                </div>
              </div>
            )}
          </div>
          <div className={activeStep == 4 || activeStep == 0 ?  this.props.userType == 'claimant' ? classes.footClaimant :  this.props.userType == 'respondent' ? classes.footRespondent: classes.footAward : null}>
          {this.props.isDesktop && <Footer/>}
          </div>
          
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
    const caseData = state.caseInfo && state.caseInfo.caseData ? state.caseInfo.caseData : {};
    let uniqueId = localStorage.getItem('token');
    let userType = '';
    if(caseData.claimantUniqueId == uniqueId){
        userType = 'claimant';
    }else if(caseData.respondentUniqueId == uniqueId){
        userType = 'respondent';
    }
  else{
    userType = "claimant";
  }

    if (caseData.agreement_type == 'EstateAgentDispute'){
        console.log('@verification caseData.a2@: '+caseData.a2 == 'vendor')
        if (caseData.a1  == 'seperate'){
            return {
                claimantUniqueId: state.caseInfo.claimantUniqueId,
                respondentUniqueId: state.caseInfo.respondentUniqueId,
                isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                telephone: caseData.namesOfA2[0].a11b,
                email: caseData.namesOfA2[0].a11a,
                caseData: caseData,
                userType: userType,
                isAuthenticated: state.auth.token !== null,
                conversationId: state.caseInfo.conversationId,
                caseId: state.caseInfo.caseId,
                twofa: state.auth.twofa,
                loadingCaseInfo: state.caseInfo.loading,
                loadingStepCompleted: state.onBoarding.loading,
                steps_completed: state.caseInfo[`${state.caseInfo.userType}_steps_completed`],
                newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`],
            }
        }
        else if ((caseData.a2  == 'purchaser' || caseData.a2  == 'vendor') && caseData.a1  !== undefined){
            if (userType == 'claimant'){
                if (caseData.a2  == 'vendor'){
                    return {
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                        // telephone: caseData.namesOfA2[0].a11b,
                        telephone: caseData.a3c,
                        email: caseData.a3b,
                        caseData: caseData,
                        userType: userType,
                        isAuthenticated: state.auth.token !== null,
                        conversationId: state.caseInfo.conversationId,
                        caseId: state.caseInfo.caseId,
                        twofa: state.auth.twofa,
                        loadingCaseInfo: state.caseInfo.loading,
                        loadingStepCompleted: state.onBoarding.loading,
                        steps_completed: state.caseInfo[`${state.caseInfo.userType}_steps_completed`],
                        newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`],
                    }
                }
                
                
            }
            else if (userType == 'respondent'){
                if (caseData.a2  == 'vendor'){
                    return {
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                        telephone: caseData.namesOfVendors[0].a11b,
                        email: caseData.namesOfVendors[0].a11a,
                        caseData: caseData,
                        userType: userType,
                        isAuthenticated: state.auth.token !== null,
                        conversationId: state.caseInfo.conversationId,
                        caseId: state.caseInfo.caseId,
                        twofa: state.auth.twofa,
                        loadingCaseInfo: state.caseInfo.loading,
                        loadingStepCompleted: state.onBoarding.loading,
                        steps_completed: state.caseInfo[`${state.caseInfo.userType}_steps_completed`],
                        newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`],
                    }
                } 
                else{
                    return {
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                        telephone: caseData.namesOfPurchasers[0].a12j,
                        email: caseData.namesOfPurchasers[0].a12i,
                        caseData: caseData,
                        userType: userType,
                        isAuthenticated: state.auth.token !== null,
                        conversationId: state.caseInfo.conversationId,
                        caseId: state.caseInfo.caseId,
                        twofa: state.auth.twofa,
                        loadingCaseInfo: state.caseInfo.loading,
                        loadingStepCompleted: state.onBoarding.loading,
                        steps_completed: state.caseInfo[`${state.caseInfo.userType}_steps_completed`],
                        newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`],
                    }
                }
            }
        }
        else{
            if (userType == 'claimant'){
                console.log('verification caseData.a3c: '+caseData.a3c)
                if (caseData.a3c !== undefined){
                    
                    return {
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                        telephone: caseData.a3c,
                        email: caseData.a3b,
                        caseData: caseData,
                        userType: userType,
                        isAuthenticated: state.auth.token !== null,
                        conversationId: state.caseInfo.conversationId,
                        caseId: state.caseInfo.caseId,
                        twofa: state.auth.twofa,
                        loadingCaseInfo: state.caseInfo.loading,
                        loadingStepCompleted: state.onBoarding.loading,
                        steps_completed: state.caseInfo[`${state.caseInfo.userType}_steps_completed`],
                        newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`],
                    }
                }
            }
            else if (userType == 'respondent'){
    
                if (caseData.namesOfVendors !== undefined){
                    return {
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                        telephone: caseData.namesOfVendors[0].a11b,
                        email: caseData.namesOfVendors[0].a11a,
                        caseData: caseData,
                        userType: userType,
                        isAuthenticated: state.auth.token !== null,
                        conversationId: state.caseInfo.conversationId,
                        caseId: state.caseInfo.caseId,
                        twofa: state.auth.twofa,
                        loadingCaseInfo: state.caseInfo.loading,
                        loadingStepCompleted: state.onBoarding.loading,
                        steps_completed: state.caseInfo[`${state.caseInfo.userType}_steps_completed`],
                        newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`],
                    }
                    
                }
                else if (caseData.namesOfPurchasers !== undefined){
                    
                    return {
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                        telephone: caseData.namesOfPurchasers[0].a12j,
                        email: caseData.namesOfPurchasers[0].a12i,
                        caseData: caseData,
                        userType: userType,
                        isAuthenticated: state.auth.token !== null,
                        conversationId: state.caseInfo.conversationId,
                        caseId: state.caseInfo.caseId,
                        twofa: state.auth.twofa,
                        loadingCaseInfo: state.caseInfo.loading,
                        loadingStepCompleted: state.onBoarding.loading,
                        steps_completed: state.caseInfo[`${state.caseInfo.userType}_steps_completed`],
                        newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`],
                    }
                    
                }
                else if (caseData.namesOfA2 !== undefined){
                    return {
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                        telephone: caseData.namesOfA2[0].a11b,
                        email: caseData.namesOfA2[0].a11a,
                        caseData: caseData,
                        userType: userType,
                        isAuthenticated: state.auth.token !== null,
                        conversationId: state.caseInfo.conversationId,
                        caseId: state.caseInfo.caseId,
                        twofa: state.auth.twofa,
                        loadingCaseInfo: state.caseInfo.loading,
                        loadingStepCompleted: state.onBoarding.loading,
                        steps_completed: state.caseInfo[`${state.caseInfo.userType}_steps_completed`],
                        newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`],
                    }
                    
                }
            }
        }
        
    }
    else if (caseData.agreement_type == 'MoneyLent'){
        
        return {
            claimantUniqueId: state.caseInfo.claimantUniqueId,
            respondentUniqueId: state.caseInfo.respondentUniqueId,
            isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
            telephone: state.caseInfo[`${state.caseInfo.userType}_telephone`],
            email: `${state.caseInfo.userType == 'claimant' ? caseData.lender_email_address : caseData.borrower_email_address}`,
            caseData: caseData,
            userType: userType,
            isAuthenticated: state.auth.token !== null,
            conversationId: state.caseInfo.conversationId,
            caseId: state.caseInfo.caseId,
            twofa: state.auth.twofa,
            loadingCaseInfo: state.caseInfo.loading,
            loadingStepCompleted: state.onBoarding.loading,
            steps_completed: state.caseInfo[`${state.caseInfo.userType}_steps_completed`],
            newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`],
        }
    }
    else if (caseData.agreement_type == 'creditcard'){
        
        return {
            claimantUniqueId: state.caseInfo.claimantUniqueId,
            respondentUniqueId: state.caseInfo.respondentUniqueId,
            isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
            telephone: `${state.caseInfo.userType == 'claimant' ? caseData.a8c : caseData.a16b}`,
            email: `${state.caseInfo.userType == 'claimant' ? caseData.a8b : caseData.a16a}`,
            caseData: caseData,
            userType: userType,
            isAuthenticated: state.auth.token !== null,
            conversationId: state.caseInfo.conversationId,
            caseId: state.caseInfo.caseId,
            twofa: state.auth.twofa,
            loadingCaseInfo: state.caseInfo.loading,
            loadingStepCompleted: state.onBoarding.loading,
            steps_completed: state.caseInfo[`${state.caseInfo.userType}_steps_completed`],
            newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`],
        }
    }
    else if (caseData.agreement_type == 'other_dispute'){
        if (userType == 'claimant'){
            return {
                claimantUniqueId: state.caseInfo.claimantUniqueId,
                respondentUniqueId: state.caseInfo.respondentUniqueId,
                isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                telephone: caseData.a8c,
                email: caseData.a8b,
                caseData: caseData,
                userType: userType,
                isAuthenticated: state.auth.token !== null,
                conversationId: state.caseInfo.conversationId,
                caseId: state.caseInfo.caseId,
                twofa: state.auth.twofa,
                loadingCaseInfo: state.caseInfo.loading,
                loadingStepCompleted: state.onBoarding.loading,
                steps_completed: state.caseInfo[`${state.caseInfo.userType}_steps_completed`],
                newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`],
            }
        }
        else if (userType == 'respondent'){
            return {
                claimantUniqueId: state.caseInfo.claimantUniqueId,
                respondentUniqueId: state.caseInfo.respondentUniqueId,
                isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                telephone: caseData.a16b,
                email: caseData.a16a,
                caseData: caseData,
                userType: userType,
                isAuthenticated: state.auth.token !== null,
                conversationId: state.caseInfo.conversationId,
                caseId: state.caseInfo.caseId,
                twofa: state.auth.twofa,
                loadingCaseInfo: state.caseInfo.loading,
                loadingStepCompleted: state.onBoarding.loading,
                steps_completed: state.caseInfo[`${state.caseInfo.userType}_steps_completed`],
                newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`],
            }
        }
    }
    else if (caseData.agreement_type == 'SalesOfGoods' ||
            caseData.agreement_type == 'serviceDispute' || 
            caseData.agreement_type == 'insuranceDispute'){
        if (userType == 'claimant'){
            return {
                claimantUniqueId: state.caseInfo.claimantUniqueId,
                respondentUniqueId: state.caseInfo.respondentUniqueId,
                isVerified: state.caseInfo[`${userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                telephone: caseData.a8c,
                email: caseData.a8b,
                caseData: caseData,
                userType: userType,
                isAuthenticated: state.auth.token !== null,
                conversationId: state.caseInfo.conversationId,
                caseId: state.caseInfo.caseId,
                twofa: state.auth.twofa,
                loadingCaseInfo: state.caseInfo.loading,
                loadingStepCompleted: state.onBoarding.loading,
                steps_completed: state.caseInfo[`${state.caseInfo.userType}_steps_completed`],
                newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`],
            }
        }
        else if (userType == 'respondent'){
            return {
                claimantUniqueId: state.caseInfo.claimantUniqueId,
                respondentUniqueId: state.caseInfo.respondentUniqueId,
                isVerified: state.caseInfo[`${userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                telephone: caseData.a16b,
                email: caseData.a16a,
                caseData: caseData,
                userType: userType,
                isAuthenticated: state.auth.token !== null,
                conversationId: state.caseInfo.conversationId,
                caseId: state.caseInfo.caseId,
                twofa: state.auth.twofa,
                loadingCaseInfo: state.caseInfo.loading,
                loadingStepCompleted: state.onBoarding.loading,
                steps_completed: state.caseInfo[`${state.caseInfo.userType}_steps_completed`],
                newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`],
            }
        }
    }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onAuth: (username, password) => dispatch(actions.auth(username, password)),
    onBoardingStepCompletion: (uniqueId, caseId, userType, step_completed) => dispatch(actions.onBoardingStepCompletion(uniqueId, caseId, userType, step_completed)),
    getCaseInfo: (caseId, uniqueId) => dispatch(actions.getCaseInfo(caseId, uniqueId)),
    getUserInformation: (uniqueId) => dispatch(actions.getUserInformation(uniqueId)),
  }
}

const mapSizesToProps = sizes => ({
  isMobile: withSizes.isMobile(sizes),
  isTablet : withSizes.isTablet(sizes),
  isDesktop : withSizes.isDesktop(sizes),
  isGtMobile : withSizes.isGtMobile(sizes),
  isGtTablet : withSizes.isGtTablet(sizes),
  isStTablet : withSizes.isStTablet(sizes),
  isStDesktop : withSizes.isStDesktop(sizes),
  isTabletAndGreater : withSizes.isTabletAndGreater(sizes),
  isTabletAndSmaller : withSizes.isTabletAndSmaller(sizes),
})

OnBoarding.contextTypes = {
  t: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(withSizes(mapSizesToProps) (withStyles(styles)(withRouter(OnBoarding))));